<footer>
    <div class="width-container">
        @if(currentRoute == "/") {
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
            <p tabindex="-1" id="footnote2" [innerHtml]="'FOOTER.FOOTNOTE2' | translate:data"></p>
            <p  [innerHtml]="'FOOTER.DISCLAIMER' | translate:data"></p>
        } 
        @else if (currentRoute == "/confirmation") {
            <p [innerHtml]="'FOOTER.CONFIRMATION_TEXT' | translate:data"></p>
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
        }@else {
            <div role="button" aria-label="terms and conditions popup" id="footnote1" tabindex="0" class="info-terms" [innerHtml]="'FOOTER.TERMS_TITLE' | translate" (click)="showTerms()" (keydown.enter)="showTerms()"></div>
        }
    </div>
</footer>